export enum EmailDisplayName {
  AppName = 'appName',
  Customized = 'customized',
}
